import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { buildApiUrl, getAuthHeaders } from "../../api/apiClient";
import {
  fetchFieldsTypeFailure,
  fetchFieldsTypeStart,
  fetchFieldsTypeSuccess,
} from "../../store/features/fieldsType/fieldsTypeSlice";

const URL = buildApiUrl("/api/v1/field_type/field_type/");

const getFieldsTypeApi = async (accessToken, search = "") => {
  try {
    const response = await axios.get(URL, {
      headers: getAuthHeaders(accessToken),
      params: {
        search: search || null,
      },
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchFieldsTypeSaga(action) {
  try {
    const { accessToken, search } = action.payload;
    const fieldsTypeData = yield call(getFieldsTypeApi, accessToken, search);
    yield put(fetchFieldsTypeSuccess(fieldsTypeData));
  } catch (error) {
    yield put(fetchFieldsTypeFailure(error.message));
  }
}

export default function* fieldsTypeSaga() {
  yield takeLatest(fetchFieldsTypeStart.type, fetchFieldsTypeSaga);
}
